import React from "react";

export const Premier = {
    title: "Premier",
    subTitleOne:
    <div>
        For individuals and businesses looking for a trusted partner.
    </div>,
    description: " ",
    listHeader: "Package Includes",
    listElements: [
      "Standard Package +",
      "Tax Planning",
      "Semi-Annual Tax Estimates",
      "Quarterly Financial Reporting",
      "Access to your accountant for year-round questions",
    ]
};



// WEBPACK FOOTER //
// ./src/components/Packages/constants/Premier.constants.js